import React, { useCallback, useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import { SalePropContext } from '../components/a-sale';
import ImgPicture from '../components/img-picture';
import * as _ from '../../ts/const';
import { sendGtag } from '../../ts/modules/sendgtag';
const SaleItemNav = ({ type, url, endOfSale, name }) => {
    const saleProp = useContext(SalePropContext);
    const [alt, setAlt] = useState();
    const [className, setClassName] = useState(classNames('nav-goto-store', type));
    // ボタンのクリック、イベント計測
    const handleClick = useCallback(() => {
        sendGtag(`SALE_${type}_${name}`, _.IS_DEV);
    }, [
        type,
        name
    ]);
    // セール終了の場合は無効状態のCSSクラスを付与
    useEffect(() => {
        if (saleProp?.sale_status === 2 || endOfSale) {
            setClassName(classNames('nav-goto-store', type, 'disabled'));
        }
    }, [
        endOfSale, saleProp
    ]);
    // Altを設定
    useEffect(() => {
        switch (type) {
            case 'ps5':
                setAlt('PlayStation&reg;5');
                break;
            case 'ps4':
                setAlt('PlayStation&reg;4');
                break;
            case 'ns':
                setAlt('Nintendo Switch');
                break;
            case 'ds':
                setAlt('Nintendo 3DS');
                break;
            case 'wiiu':
                setAlt('Wii U');
                break;
        }
    }, [
        type
    ]);
    return (React.createElement("a", { className: className, href: url, onClick: handleClick, target: "_blank", rel: "noopener" },
        React.createElement(ImgPicture, { fileName: `./assets/img/misc/logo/${type}`, alt: alt })));
};
export default SaleItemNav;
